module.exports = __webpack_public_path__ + "static/step-2@2x-a0fa9ae55d64a71c720dc0b925d81653.png";